import React, { useEffect, useState } from "react";
import styles from "../../management/db-list/DBList.module.scss";
import listStyles from "../../../common/management/ListWrapper.module.scss";
import { SonicGameSelectionData } from "../../../common/classes/SonicGameSelection";
import ListWrapper from "../../../common/management/ListWrapper";
import LoadingSpinner from "../../../common/LoadingSpinner";
import { SonicTermData } from "../../../common/classes/SonicTerm";
import ActionBtn from "../../../common/management/ActionBtn";
import SelectTermModal from "../../../common/forms/SelectTermModal";
import { useNavigate } from "react-router-dom";

type Props = {
  isLoading: boolean;
  gameSelections: Array<SonicGameSelectionData>;
  games: Array<SonicTermData>;
  handleSearch: (keyword: string) => void;
};
const GameSelectionList: React.FC<Props> = ({
  isLoading,
  games,
  gameSelections,
  handleSearch,
}) => {
  const navigate = useNavigate();
  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  const setModal = (value: boolean) => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = value ? "hidden" : "unset";
    }

    setIsModalShown(value);
  };

  useEffect(() => {
    return () => {
      const html = document.querySelector("html");
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, []);

  return (
    <ListWrapper pageTitle={"ゲーム項目一覧"}>
      <div className={listStyles["f-listWrapper__content-list__btn-area"]}>
        <ActionBtn
          label="追加する"
          icon={["fal", "plus-circle"]}
          onClick={() => setModal(true)}
        />
      </div>
      <SelectTermModal
        isModalShown={isModalShown}
        isLoading={isLoading}
        termName="ゲーム"
        options={games}
        handleSearch={handleSearch}
        handleClose={() => setModal(false)}
        handleSelect={(value: SonicTermData) => {
          navigate(`/admin/game-selection/${value.id}`, { replace: false });
        }}
      />
      {isLoading ? (
        <LoadingSpinner space={1} admin_page={true} />
      ) : (
        <div className={styles["f-dbList"]}>
          <div
            className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["game-selection"]}`}
          >
            <div>ゲーム名</div>
            <div>アクション</div>
          </div>

          {gameSelections.map((selection) => (
            <div
              key={selection.id}
              className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["game-selection"]}`}
            >
              <div>
                {games.filter((game) => game.id === selection.game_id)[0]?.name}
              </div>
              <div>
                <ActionBtn
                  label="追加する"
                  icon={["fal", "plus-circle"]}
                  link={`/admin/game-selection/${selection.game_id}`}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </ListWrapper>
  );
};

export default GameSelectionList;
